<template>
  <Header>
    <Menu mode="horizontal" theme="dark" active-name="1">
      <!-- <div class="layout-logo">医诺云检HIS</div> -->
      <div class="layout-logo">
        <img src="../../assets/img/logo1.png" alt="">
      </div>
      <span style="color:#fff;line-height:48px;margin-left:20px;font-weight:600"> {{nameP}}</span>
      <div class="layout-nav">
        <!-- <MenuItem name="1">
          <Icon type="ios-navigate"></Icon>
          手机查报告
        </MenuItem> -->
        <MenuItem name="2">
           <Dropdown  @on-click="exit" :transfer="true">
             <Icon type="md-person"/>
              <a href="javascript:void(0)">
                  {{$store.state.userName.hospitalName}}
                  {{$store.state.userName.userName}}
              </a>
              <Dropdown-menu slot="list" :transfer="true">
                  <!-- <Dropdown-item name="person-center">个人中心</Dropdown-item> -->
                  <Dropdown-item name='exit'>退出</Dropdown-item>
              </Dropdown-menu>
          </Dropdown>
        </MenuItem>
      </div>
    </Menu>
  </Header>
</template>
<script>
export default {
    name:"YnHeader",
    data(){
      return{
        nameP:localStorage.getItem("his_pId")==98?"瑞能医学检验实验室":""
      }
    },
    methods:{
      exit(w){
        console.log(w)
        w==='exit'?this.$router.push('/'):"";
        window.sessionStorage.clear();
        this.$store.state.tags = [];
        this.$store.state.patientName = '';
        this.$store.state.phone = '';
        this.$store.state.userName = {};
        this.$store.state.expandName = '';
        this.$store.state.sickName = '';
      }
    }
}
</script>
<style lang="less" scoped>
.layout{
    background: #f5f7f9;
    position: relative;
    overflow: hidden;
    height: 100%;
}
.layout-logo{
   border-radius: 3px;
   float: left;
   color: #fff;
   font-size: 20px;
}
.layout-logo>img{
  width: 223px;
}
.layout-nav{
    float:right;
    margin: 0 auto;
    margin-right: 20px;
}
.ivu-menu-dark.ivu-menu-horizontal .ivu-menu-item, .ivu-menu-dark.ivu-menu-horizontal .ivu-menu-submenu,a{
  color: #fff;
}
.ivu-menu-item {
    display: block;
    outline: none;
    list-style: none;
    font-size: 16px;
    position: relative;
    z-index: 1;
    cursor: pointer;
    -webkit-transition: all 0.2s ease-in-out;
    transition: all 0.2s ease-in-out;
}
</style>




// WEBPACK FOOTER //
// src/views/index/YnHeader.vue